import api, { type RequestBody, multipart } from ".";
import type { PaginatedList } from "src/types/api";
import type { CustomerDetailData, CustomerRow } from "src/types/customer";

/** Query accepted by the customer list endpoints. */
export interface CustomerQuery {
	page?: number;
	limit?: number;
	search?: string;
}

export const getCustomers = (params?: CustomerQuery) => api.get<PaginatedList<CustomerRow>>("/customers", { params });

export const getArchivedCustomers = (params?: CustomerQuery) => api.get<PaginatedList<CustomerRow>>("/customers/archived", { params });

export const getCustomerDetails = (uuid: string) => api.get<CustomerDetailData>(`/customers/${uuid}/view`);

export const archiveCustomer = ({ uuid }: { uuid: string }) => api.patch(`/customers/${uuid}/archive`);

export const unArchiveCustomer = ({ uuid }: { uuid: string }) => api.patch(`/customers/${uuid}/unarchive`);

export const createCustomer = (data: RequestBody) => api.post<CustomerRow>("/customers/store", data);

export const uploadCustomers = (data: FormData) => api.post("/customers/add-bulk", data, multipart);

export const updateCustomer = ({ uuid, ...data }: { uuid: string } & RequestBody) => api.patch(`/customers/${uuid}/update`, data);

export const generateVirtualAccount = ({ uuid, ...data }: { uuid: string; bvn?: string }) => api.post(`/customers/${uuid}/virtual-account`, data);
